import React from 'react';
import { Platform, View } from 'react-native';
import type { SvgProps } from 'react-native-svg';

import colors from '~/assets/themes/colors';
import { Text } from '~/components';

interface Props {
  title: string;
  icon: React.FC<SvgProps>;
  children: string | React.ReactNode;
}

const Step: React.FC<Props> = ({ title, children, icon: Icon }) => {
  return (
    <View
      className={`px-4 py-6 rounded-lg shadow bg-light-100 my-3 ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <View className="flex-row items-start">
        <Icon height={24} width={24} color={colors.primary[600]} />

        <View className="flex-1">
          <Text className="ml-2 text-base color-gray-700">{title}</Text>
          <Text className="ml-2 mt-2 text-gray-400 text-sm">{children}</Text>
        </View>
      </View>
    </View>
  );
};

export default Step;
